// Client-side room image helpers. Prefer the pre-resolved `backgroundUrl`
// the server injects via resolveRoomImages(), with a key-based fallback for
// edge cases where that field is missing.
window.EM = window.EM || {};
window.EM.roomImages = {
  backgroundUrl: function (room) {
    if (!room) return "";
    return room.backgroundUrl || (room.backgroundImage && room.backgroundImage.url) || (room.key ? "/images/rooms/" + room.key + ".jpg" : "");
  },
};
